/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Hourly_Rate_EstimateInputs */

const en_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. Hourly Rate (USD)`)
};

const es_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifa por hora estimada (USD)`)
};

const fr_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux horaire estimé (USD)`)
};

const de_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzter Stundensatz (USD)`)
};

const ja_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推定時給 (USD)`)
};

const zh_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预计时薪 (美元)`)
};

const ar_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأجر بالساعة المقدر (دولار أمريكي)`)
};

const id_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimasi Tarif Per Jam (USD)`)
};

const it_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tariffa Oraria Stimata (USD)`)
};

const ru_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ожидаемая почасовая ставка (USD)`)
};

const pt_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa Horária Estimada (USD)`)
};

const ko_field_hourly_rate_estimate = /** @type {(inputs: Field_Hourly_Rate_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예상 시간당 요금 (USD)`)
};

/**
* | output |
* | --- |
* | "Est. Hourly Rate (USD)" |
*
* @param {Field_Hourly_Rate_EstimateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_hourly_rate_estimate = /** @type {((inputs?: Field_Hourly_Rate_EstimateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Hourly_Rate_EstimateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_hourly_rate_estimate(inputs)
	if (locale === "es") return es_field_hourly_rate_estimate(inputs)
	if (locale === "fr") return fr_field_hourly_rate_estimate(inputs)
	if (locale === "de") return de_field_hourly_rate_estimate(inputs)
	if (locale === "ja") return ja_field_hourly_rate_estimate(inputs)
	if (locale === "zh") return zh_field_hourly_rate_estimate(inputs)
	if (locale === "ar") return ar_field_hourly_rate_estimate(inputs)
	if (locale === "id") return id_field_hourly_rate_estimate(inputs)
	if (locale === "it") return it_field_hourly_rate_estimate(inputs)
	if (locale === "ru") return ru_field_hourly_rate_estimate(inputs)
	if (locale === "pt") return pt_field_hourly_rate_estimate(inputs)
	return ko_field_hourly_rate_estimate(inputs)
});